import { render, staticRenderFns } from "./AppTableMethods.vue?vue&type=template&id=0235ad09&"
import script from "./AppTableMethods.vue?vue&type=script&lang=ts&"
export * from "./AppTableMethods.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports